import JSZip from 'jszip';

/**
 * Extracts slide IDs from a PPTX ArrayBuffer in presentation order.
 * Index 0 = first slide, index 1 = second slide, etc.
 *
 * PPTX files are ZIP archives containing `ppt/presentation.xml` with a slide
 * ID list like:
 *   <p:sldIdLst>
 *     <p:sldId id="256" r:id="rId2"/>   <!-- Slide 1 -->
 *     <p:sldId id="257" r:id="rId3"/>   <!-- Slide 2 -->
 *   </p:sldIdLst>
 *
 * The `id` attribute is the value that PowerPoint's `insertSlidesFromBase64`
 * accepts in the `sourceSlideIds` option.
 */
export async function extractSlideIds(
  pptxBuffer: ArrayBuffer
): Promise<string[]> {
  const zip = await JSZip.loadAsync(pptxBuffer);

  const xml = await zip.file('ppt/presentation.xml')?.async('string');
  if (!xml) {
    throw new Error('Invalid PPTX: missing ppt/presentation.xml');
  }

  const doc = new DOMParser().parseFromString(xml, 'application/xml');

  const slideIds: string[] = [];
  const elements = doc.getElementsByTagNameNS('*', 'sldId');
  for (let i = 0; i < elements.length; i++) {
    const id = elements[i].getAttribute('id');
    if (id) {
      slideIds.push(id);
    }
  }

  return slideIds;
}
